// extracted by mini-css-extract-plugin
export default {"content":"HomePage_content__L+Tmc","greetings-and-avatar-container":"HomePage_greetings-and-avatar-container__Pz8uA"};